module.exports = __webpack_public_path__ + "static/media/17_eric_chiu.e07abe6c.jpeg";